
export const firebaseConfig = {
    apiKey: "AIzaSyAempNNCLeT9GBy_O6qL1Do9RWhPmP7VZY",
    authDomain: "doctor-portal-d0e06.firebaseapp.com",
    projectId: "doctor-portal-d0e06",
    storageBucket: "doctor-portal-d0e06.appspot.com",
    messagingSenderId: "525407048686",
    appId: "1:525407048686:web:65a869391b623ed75574ff"
};
